module.exports = __webpack_public_path__ + "static/img/bout.80a8003.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bout.png
// module id = pDsz
// module chunks = 1